<template>
    <div class="px-4" v-if="$page.props.flash">
        <div
            class="bg-red-300 text-red-800"
            :class="defaultFlashClasses"
            v-if="$page.props.flash.error && show"
        >
            <div :class="defaultIconClasses">
                <i class="fas fa-exclamation-circle mt-2"></i>
            </div>
            <div :class="defaultTextClasses" v-html="$page.props.flash.error">
            </div>
            <div :class="defaultCloseClasses" @click="show = false">
                <i class="fas fa-times"></i>
            </div>
        </div>

        <div
            class="bg-green-300 text-green-800"
            :class="defaultFlashClasses"
            v-if="$page.props.flash.success && show"
        >
            <div :class="defaultIconClasses">
                <i class="far fa-check-circle"></i>
            </div>
            <div :class="defaultTextClasses" v-html="$page.props.flash.success">
            </div>
            <div :class="defaultCloseClasses" @click="show = false">
                <i class="fas fa-times"></i>
            </div>
        </div>

        <div
            class="bg-blue-light-300 text-blue-dark-500"
            :class="defaultFlashClasses"
            v-if="$page.props.flash.info && show"
        >
            <div :class="defaultIconClasses">
                <i class="fas fa-info-circle"></i>
            </div>
            <div :class="defaultTextClasses" v-html="$page.props.flash.info">
            </div>
            <div :class="defaultCloseClasses" @click="show = false">
                <i class="fas fa-times"></i>
            </div>
        </div>

        <div
            class="bg-orange-300 text-orange-800 "
            :class="defaultFlashClasses"
            v-if="$page.props.flash.warning && show"
        >
            <div :class="defaultIconClasses">
                <i class="fas fa-exclamation-triangle"></i>
            </div>
            <div :class="defaultTextClasses" v-html="$page.props.flash.warning">
            </div>
            <div :class="defaultCloseClasses" @click="show = false">
                <i class="fas fa-times"></i>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            show: true,
            defaultFlashClasses: 'flex w-full p-3 mb-6 rounded-md font-semibold',
            defaultIconClasses: 'text-2xl pr-2',
            defaultTextClasses: 'pt-1 pr-2 flex-auto',
            defaultCloseClasses: 'text-lg pt-1 leading-6 cursor-pointer hover:opacity-75 transition',
        }
    },
    watch: {
        '$page.props.flash': {
            handler() {
                this.show = true
            },
            deep: true,
        }
    }
}
</script>

